import { connect } from "react-redux";

export default connect((state) => ({
  websocket: state.websocket,
}));
